import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import AccountBalanceIcon from "@material-ui/icons/AccountBalance";
import CheckIcon from "@material-ui/icons/Check";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import "../MembershipPage.css";

@inject("hgSuperPayAddonStore", "templateStore")
@observer
class HgSuperPayAddonSection extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showCancelConfirm: false
        };
    }

    componentDidMount() {
        this.props.hgSuperPayAddonStore.loadAddonStatus();
    }

    handleActivate = async () => {
        try {
            const response = await this.props.hgSuperPayAddonStore.startCheckout();
            if (response?.checkoutUrl) {
                window.open(response.checkoutUrl, "_blank");
            }
        } catch (e) {
            let message;
            if (e?.status === 409) {
                message = "You already have an active HG Super Pay subscription.";
            } else if (e?.status === 404) {
                message = "Billing must be set up before activating this add-on.";
            } else {
                message = "Failed to start checkout. Please try again.";
            }
            this.props.templateStore.openSnackbar(message);
        }
    };

    handleCancelClick = () => {
        this.setState({ showCancelConfirm: true });
    };

    handleCancelConfirm = async () => {
        this.setState({ showCancelConfirm: false });
        try {
            await this.props.hgSuperPayAddonStore.cancelAddon();
            this.props.templateStore.openSnackbar("HG Super Pay add-on cancelled.");
        } catch (e) {
            let message;
            if (e?.status === 409) {
                message = "This subscription is already cancelled.";
            } else if (e?.status === 404) {
                message = "No active subscription found to cancel.";
            } else {
                message = "Failed to cancel add-on. Please try again.";
            }
            this.props.templateStore.openSnackbar(message);
        }
    };

    handleCancelDismiss = () => {
        this.setState({ showCancelConfirm: false });
    };

    getNextMonthName() {
        const d = new Date();
        d.setMonth(d.getMonth() + 1);
        return d.toLocaleString("default", { month: "long" });
    }

    render() {
        const {
            addonStatus,
            currentMonthUsage,
            temporaryFeeAmountFormatted,
            isActionLoading
        } = this.props.hgSuperPayAddonStore;

        const { showCancelConfirm } = this.state;

        const isActive = addonStatus === "active";
        const isStatusLoading = addonStatus === "loading";
        const buttonDisabled = isStatusLoading || isActionLoading;

        return (
            <div id="hg-super-pay-addon" style={{ marginTop: 40 }}>
                <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 16 }}>
                    <h3 style={{ margin: 0, fontSize: 18, fontWeight: 600, color: "#333" }}>Add-ons</h3>
                    <div style={{ flex: 1, height: 1, background: "#eee" }} />
                </div>

                <div className="addon-card">
                    <div className="addon-card-header">
                        <div className="addon-card-icon">
                            <AccountBalanceIcon style={{ fontSize: 24, color: "#fe0d9d" }} />
                        </div>
                        <div className="addon-card-info">
                            <div className="addon-card-name">HG Super Pay</div>
                            <div className="addon-card-tagline">
                                Submit superannuation payments for your sole trader artists and players via HG Super Pay. Australian customers only.
                            </div>
                        </div>
                        {isActive && (
                            <div className="addon-active-badge">
                                <CheckIcon style={{ fontSize: 14 }} /> Active
                            </div>
                        )}
                    </div>

                    <div className="addon-card-body">
                        <div className="addon-pricing-info">
                            <span className="addon-price">$1.50</span>
                            <span className="addon-price-label"> ex GST per submission, billed on the 5th of each month for the prior month's usage</span>
                        </div>

                        {isActive && (
                            <div className="addon-usage-line">
                                This month: <strong>{currentMonthUsage} submission{currentMonthUsage !== 1 ? "s" : ""}</strong>
                                {temporaryFeeAmountFormatted && (
                                    <>
                                        {" "}≈{" "}
                                        <strong>{temporaryFeeAmountFormatted}</strong>
                                    </>
                                )}
                                <span className="addon-usage-note"> — billed 5th {this.getNextMonthName()}</span>
                            </div>
                        )}

                        <div className="addon-card-actions">
                            {buttonDisabled ? (
                                <button className="addon-btn addon-btn-disabled" disabled>
                                    {isStatusLoading ? "Loading..." : "Processing..."}
                                </button>
                            ) : isActive ? (
                                <button className="addon-btn addon-btn-cancel" onClick={this.handleCancelClick}>
                                    Cancel Add-on
                                </button>
                            ) : (
                                <button className="addon-btn addon-btn-activate" onClick={this.handleActivate}>
                                    Activate
                                </button>
                            )}
                        </div>
                    </div>
                </div>

                <Dialog open={showCancelConfirm} onClose={this.handleCancelDismiss}>
                    <DialogTitle>Cancel HG Super Pay</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Are you sure you want to cancel HG Super Pay? You will lose access at the end of the current billing period and will no longer be able to submit superannuation payments.
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleCancelDismiss} color="primary">
                            Keep Add-on
                        </Button>
                        <Button onClick={this.handleCancelConfirm} color="secondary">
                            Yes, Cancel
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}

export default HgSuperPayAddonSection;
